import ajax from '../utils/ajax'

export default {
    types: () => ajax.get('/api/plots/types'),
    rect: params => ajax.post('/api/plots/rect', params),
    search: (keyword, options) => ajax.post('/api/plots/search', Object.assign({}, options, {keyword})),
    load: id => ajax.get('/api/plots/load', {params: {id}}),
    select: item => ajax.post('/api/plots/select', {class: item.class, id: item.id, displayName: item.displayName, type: item.type, keyword: item.keyword}),
    selectHistory: () => ajax.get('/api/plots/selectHistory'),
    loadVessel: (mmsi, wash) => ajax.get('/api/plots/loadVessel', {params: {mmsi, wash: wash ? 1 : 0}}),
    vesselTrail: (mmsi, from, to, wash) => ajax.get('/api/plots/vesselTrail', {params: {mmsi, from, to, wash}}),
    vesselThermo: (mmsi, wash) => ajax.get('/api/plots/vesselThermo', {params: {mmsi, wash: wash ? 1 : 0}}),
    vesselBerth: mmsi => ajax.get('/api/plots/vesselBerth', {params: {mmsi}}),
    route: (startText, targetText, maxWeight, throughPositions) => ajax.get("/api/plots/route", {
        params: {startText, targetText, maxWeight, throughPositions}
    }),
    remove: id => ajax.post("/api/plots/remove", {id}),
    save: (plot, errorHandler) => ajax.onError(errorHandler).post("/api/plots/save", plot),
    changeCoordinate: (id, lon, lat) => ajax.post("/api/plots/coordinate", {id, lon, lat}),
    loadVesselFilters: () => ajax.get('/api/plots/vesselFilters'),
    saveVesselFilters: filters => ajax.put('/api/plots/vesselFilters', filters),
    vessels: params => ajax.post('/api/plots/vessels', params),
    measureWeight: (polygon, type) => ajax.post('/fairway/api/polygon', {polygon, type}),
    listRectPlots: types => ajax.get("/api/plots/rectPlots", {params: {types: (types || []).join()}}),
    saveRectPlot: rectPlot => ajax.post("/api/plots/rectPlot", rectPlot),
    removeRectPlot: (id, rowVersion) => ajax.post("/api/plots/removeRectPlot", {id, rowVersion}),
    vesselMapUrl: (hash, delegation) => ajax.get('/api/plots/vesselMapUrl', {params: {hash, delegation}}),
    listLinePlots: types => ajax.get("/api/plots/linePlots", {params: {types: (types || []).join()}}),
    saveLinePlot: rectPlot => ajax.post("/api/plots/linePlot", rectPlot),
    removeLinePlot: (id, rowVersion) => ajax.post("/api/plots/removeLinePlot", {id, rowVersion}),
};
